import SolutionUsers from './SolutionUsers';

export default SolutionUsers;
